export const fetchAuditsByOrg = async (user, orgId) => {
  const response = await fetch(`/api/auditing/${orgId}/audits-by-org`, {
    headers: {
      // prettier-ignore
      'Authorization': `Bearer ${user.token}`
    }
  });
  //convert again json array of objects to javascript array of objects
  const json = await response.json();
  if (response.ok) {
    return json;
  } else {
    throw new Error(json?.msg || `Failed to fetch audit log for org id: ${orgId}`);
  }
};

export const fetchAuditsByUser = async (user) => {
  const response = await fetch(`/api/auditing/${user?.userId ?? '0'}/audits-by-user`, {
    headers: {
      // prettier-ignore
      'Authorization': `Bearer ${user.token}`
    }
  });
  //convert again json array of objects to javascript array of objects
  const json = await response.json();
  if (response.ok) {
    return json;
  } else {
    throw new Error(json?.msg || `Failed to fetch audit log for user id: ${user?.userId}`);
  }
};
